import { EsimStatus } from '@models/stock';
import type { UiMeta } from './uiMeta';
import { getUiLabel, getUiMeta, toLabelMap } from './uiMeta';

export const ESIM_STATUS_META = {
  [EsimStatus.READY]: {
    label: 'Ready',
    chip: { color: 'primary', variant: 'filled' },
    order: 1,
  },
  [EsimStatus.SHIPPED]: {
    label: 'Shipped',
    chip: { color: 'default', variant: 'outlined' },
    order: 2,
  },
  [EsimStatus.PENDING]: {
    label: 'Pending',
    chip: { color: 'warning', variant: 'outlined' },
    order: 3,
  },
  [EsimStatus.EXPIRED]: {
    label: 'Expired',
    chip: { color: 'warning', variant: 'filled' },
    order: 4,
  },
  [EsimStatus.CANCELED]: {
    label: 'Canceled',
    chip: { color: 'error', variant: 'filled' },
    order: 5,
  },
} as const satisfies Record<EsimStatus, UiMeta>;

export const ESIM_STATUS_LABELS = toLabelMap(ESIM_STATUS_META);

export const getEsimStatusMeta = (
  status?: EsimStatus | string | null,
) => getUiMeta(ESIM_STATUS_META, status);

export const getEsimStatusLabel = (
  status?: EsimStatus | string | null,
) => getUiLabel(ESIM_STATUS_META, status);
